import { createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../../firebase/config";
import { TalesParagraph } from "../../../utils/types/TalesParagraph";
import firebase from "firebase";
import FieldPath = firebase.firestore.FieldPath;

export const deleteHighlight = createAsyncThunk(
  "highlight/delete",
  async (highlight: TalesParagraph) => {
    try {
      const querySnapshot = await db
        .collection("highlight")
        .where("content", "==", highlight.content)
        .get();

      return querySnapshot.docs[0].ref.delete();
    } catch (e: any) {
      console.log(e);

      return Promise.reject(`Highlight non eliminato, ${e.message}`);
    }
  },
);
